import React from 'react'
import PropTypes from 'prop-types'

/**
 * Статусы заказов
 * new - в обработке
 * sent - в обработке
 * error - отменен
 * jupiter_new - в обработке
 * cancelled - отменен
 * preparing - готовим
 * ready - готов
 * ontheway - у курьера
 * delivered - доставлен
 */

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statuses: {
        new: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        sent: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        error: {
          image: 2,
          rimage: `image2.svg`,
          name: `Заказ отменен`,
          text: `Упс, что-то пошло не так`,
          color: `#3A3A3A`
        },
        jupiter_new: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        cancelled: {
          image: 2,
          rimage: `image2.svg`,
          name: `Заказ отменен`,
          text: `Упс, что-то пошло не так`,
          color: `#3A3A3A`
        },
        preparing: {
          image: 3,
          rimage: `image3.svg`,
          name: `Готовим для вас`,
          text: `Заказ готовится к отправке`,
          color: `#5A91FF`
        },
        ready: {
          image: 4,
          rimage: `image4.svg`,
          name: `Заказ готов`,
          text: `Передаем в доставку курьером`,
          color: `#F66116`
        },
        ontheway: {
          image: 5,
          rimage: `image5.svg`,
          name: `Заказ у курьера`,
          text: `Мы позвоним по прибытии`,
          color: `#A6DD2F`
        },
        delivered: {
          image: 6,
          rimage: `image6.svg`,
          name: `Заказ доставлен`,
          text: `Приятного аппетита!`,
          color: `#A6DD2F`
        },
        pending: {
          image: 1,
          rimage: `image1.png`,
          name: `Заказ не создан`,
          text: `Повторите оплату`,
          color: `#868686`
        }
      }
    }
  }

  render() {
    const { order, assets_path } = this.props,
    { statuses } = this.state

    var status = order?.status
    if(status == `new` && order?.payment_status == 'pending') status = `pending`

    if(order?.number != ``) return (
      <a
        className={`block mt-[8px] bg-cover bg-center rounded-[25px] w-[100%] overflow-hidden cursor-pointer`}
        style={{ backgroundImage: `url('/${assets_path}/images/statusPlashka.svg')`, backgroundColor: statuses[status]?.color }}
        href='/user/order'
      >
        <div className='rounded-[25px] w-[100%] h-[86px] flex items-center px-[15px] gap-[10px]'
          style={{ background: `url('/${assets_path}/images/plashki/${statuses[status]?.rimage}') no-repeat calc(100% - 20px) 10px`, backgroundSize: `120px` }}
        >
          <img src={`/${assets_path}/images/plashki/icon${statuses[status]?.image}.svg`} />
          <div>
            <div className='text-white text-[22px] font-semibold'>{statuses[status]?.name}</div>
            <div className='flex gap-[5px] items-center text-[#FFFFFF99] text-[14px]'>
              <div>Номер заказа</div>
              <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2" r="2" fill="white"/>
              </svg>
              <div>№{order?.number}</div>
            </div>
          </div>
        </div>
      </a>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  order: PropTypes.object
}

export default Main